<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <wait-cursor color="#fff"/>
      </div>
    </div>
  </transition>
</template>
<script>
import Modal from '@/components/Modal.vue'
import WaitCursor from '@/components/WaitCursor.vue';

export default {
  name: 'WaitCursorModal',
  components: {
    WaitCursor,
  },
  extends: Modal,
  props: {
  },
  methods: {
  },
};
</script>
